var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { PollRepository } from '@amityco/js-sdk';
import Modal from '../../../../core/components/Modal';
import { confirm } from '../../../../core/components/Confirm';
import PollComposer from '../../../../social/components/post/PollComposer';
import promisify from '../../../../helpers/promisify';
const PollModal = ({ targetId, targetType, onClose, onCreatePoll }) => {
    const [isDirty, setDirty] = useState(false);
    const { formatMessage } = useIntl();
    const handleSubmit = (data, mentionees, metadata) => __awaiter(void 0, void 0, void 0, function* () {
        const { pollId } = yield promisify(PollRepository.createPoll(data));
        yield onCreatePoll(pollId, data.question, mentionees, metadata);
        onClose();
    });
    const closeConfirm = () => confirm({
        title: formatMessage({ id: 'CommunityCreationModal.title' }),
        content: formatMessage({ id: 'CommunityCreationModal.content' }),
        cancelText: formatMessage({ id: 'CommunityCreationModal.cancelText' }),
        okText: formatMessage({ id: 'CommunityCreationModal.okText' }),
        onOk: onClose,
    });
    return (React.createElement(Modal, { isOpen: true, "data-qa-anchor": "poll-composer-modal", title: formatMessage({ id: 'poll_modal.title' }), clean: false, onCancel: isDirty ? closeConfirm : onClose },
        React.createElement(PollComposer, { targetId: targetId, targetType: targetType, setDirtyExternal: setDirty, onCancel: closeConfirm, onSubmit: handleSubmit })));
};
export default PollModal;
//# sourceMappingURL=PollModal.js.map